import { H2 } from 'components/ring-air/styleConstants';
import { Container, Content } from './LayoutComponents';
import { Counter } from 'components/shared/Counter';
import CustomLink from 'components/shared/CustomLink';
import styles from './ResearchSection.module.css';

const dataPoints = [
  {
    precentage: 59,
    description: 'reduction in glucose spikes',
  },
  {
    precentage: 13,
    description: 'improvement in glucose level regulation',
  },
];

export const ResearchSection = ({ className }: { className?: string }) => {
  return (
    <Container
      fill="#F5F5F5"
      className={`${styles.root}${className ? ` ${className}` : ''}`}
    >
      <Content>
        <div className={styles.content}>
          <div className={styles['description-content']}>
            <div>
              <H2>Metabolic Score is now a clinically validated marker</H2>
            </div>
            <CustomLink
              className="clinical-research"
              href="https://www.nature.com/articles/s41598-024-56933-2?_gl=1*ggzxh1*_gcl_au*MTIxODYzMDUxOS4xNzE2MjAxNzM5"
            >
              Read the study
            </CustomLink>
            <p className={styles['desktop-only']}>
              *The Metabolic Score is now a validated marker of insulin
              sensitivity and glucose metabolism. Read the study for more
              details.
            </p>
          </div>
          <div className={styles['research-descriptions']}>
            {dataPoints.map((data, index) => (
              <div key={index} className={styles['research-description']}>
                <Counter
                  className="percentage"
                  start={0}
                  end={data.precentage}
                  duration={2}
                />
                <span className={styles.description}>{data.description}</span>
              </div>
            ))}
            <p className={styles['mobile-only']}>
              *The Metabolic Score is now a validated marker of insulin
              sensitivity and glucose metabolism. Read the study for more
              details.
            </p>
          </div>
        </div>
      </Content>
    </Container>
  );
};
